import * as React from 'react';
import {ErrorInfo} from 'react';
import {showErrorMessage} from '../../helpers/PopupMessageHelpers';
import {ErrorHandler} from '../../../app/context/ErrorHandler';

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  static contextType = ErrorHandler;
  // noinspection JSDeprecatedSymbols
  context!: React.ContextType<typeof ErrorHandler>;

  constructor(props: {}) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({hasError: true});
    error.stack = errorInfo.componentStack;
    this.context.reportError(error);
  }

  render() {
    if (this.state.hasError) {
      showErrorMessage('code');
      return null;
    }
    return this.props.children;
  }
}